<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        For each of the following sets of quantum numbers, determine how many electrons in a single
        atom could have that specific set of numbers.
      </p>

      <p class="mb-2">
        <stemble-latex content="$n$" />
        =
        <number-value :value="energyLevel1" />
      </p>

      <calculation-input
        v-model="inputs.input1"
        prepend-text="$\text{Number:}$"
        append-text="$\text{electrons}$"
        class="mb-5"
        :disabled="!allowEditing"
      />

      <p class="mb-2">
        <stemble-latex content="$n$" />
        =
        <number-value :value="energyLevel2" />
        ,
        <stemble-latex content="$\ell$" />
        =
        <number-value :value="aqn2" />
      </p>

      <calculation-input
        v-model="inputs.input2"
        prepend-text="$\text{Number:}$"
        append-text="$\text{electrons}$"
        class="mb-5"
        :disabled="!allowEditing"
      />

      <p class="mb-2">
        <stemble-latex content="$n=$" />
        <number-value :value="energyLevel3" />
        ,
        <stemble-latex content="$\ell=$" />
        <number-value :value="aqn3" />
        ,
        <stemble-latex content="$m_\ell=$" />
        <number-value :value="mqn3" />
      </p>

      <calculation-input
        v-model="inputs.input3"
        prepend-text="$\text{Number:}$"
        append-text="$\text{electrons}$"
        :disabled="!allowEditing"
        class="mb-2"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import NumberValue from '../NumberValue';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question22',
  components: {
    CalculationInput,
    NumberValue,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
        input2: null,
        input3: null,
      },
    };
  },
  computed: {
    energyLevel1() {
      return this.taskState.getValueBySymbol('energyLevel1').content;
    },
    energyLevel2() {
      return this.taskState.getValueBySymbol('energyLevel2').content;
    },
    energyLevel3() {
      return this.taskState.getValueBySymbol('energyLevel3').content;
    },
    aqn2() {
      return this.taskState.getValueBySymbol('aqn2').content;
    },
    aqn3() {
      return this.taskState.getValueBySymbol('aqn3').content;
    },
    mqn3() {
      return this.taskState.getValueBySymbol('mqn3').content;
    },
  },
};
</script>
